// removed by extract-text-webpack-plugin
module.exports = {"header":"_1-Z9y _37W4X _2AJrG","searchIcon":"_3WCb_","searchBox":"_3VMyy _1RQS5"};


//////////////////
// WEBPACK FOOTER
// ./components/SearchHeader.css
// module id = 1972
// module chunks = 3